<template>
  <v-select
    id="axis-select"
    v-model="filter.eixo"
    item-text="nome"
    item-value="eixoId"
    :items="axis"
    :label="name || 'Eixo'"
    placeholder="Eixo"
    :return-object="true"
    multiple
    @change="$emit('change', filter.eixo)"
  >
    <div
      style="display: flex; padding: 0 16px; cursor: pointer"
      slot="prepend-item"
      ripple
      @click="toggle"
    >
      <div style="margin-right: 32px">
        <v-icon :color="filter.eixo.length > 0 ? 'indigo darken-4' : ''">{{
          icon
        }}</v-icon>
      </div>
      <div>Todos</div>
    </div>
    <v-divider slot="prepend-item" class="mt-2" />

    <template v-slot:selection="{ item, index }">
      <span v-if="index < maxDisplay"
        >{{ item.nome
        }}{{
          index === 0 && filter.eixo && filter.eixo.length > 1 ? "," : ""
        }}
        &nbsp;</span
      >
      <span v-if="index === maxDisplay" class="grey--text caption"
        >(+{{ filter.eixo.length - maxDisplay }} eixos)</span
      >
    </template>

    <template slot="no-data"> Nenhum Eixo retornado </template>
  </v-select>
</template>

<script>
import { axisAPI } from "@/modules/axis";

export default {
  name: "AppAxisByProjectCombobox",
  props: ["filter", "name"],
  mounted() {
    this.loadAxis();
  },
  methods: {
    loadAxis() {
      axisAPI
        .list()
        .then((resp) => {
          this.axis = resp.data;
        })
        .catch();
    },
    toggle() {
      this.$nextTick(() => {
        if (this.likesAll) {
          this.filter.eixo = [];
        } else {
          this.filter.eixo = this.axis.slice();
        }
      });
    },
  },
  computed: {
    likesAll() {
      return this.filter.eixo.length === this.axis.length;
    },
    likesSome() {
      return this.filter.eixo.length > 0 && !this.axis;
    },
    icon() {
      if (this.likesAll) return "mdi-close-box";
      if (this.likesSome) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  data() {
    return {
      maxDisplay: 1,
      axis: [],
    };
  },
};
</script>
